require.register("app/product/CreateModal", function(exports, require, module){
  $0
  
});

